import React, { useEffect, useState } from 'react';
import { Button } from 'primereact/button';
import { Message } from 'primereact/message';

const SSO_ERROR_MESSAGES = {
  invalid_assertion:
    'The SAML assertion provided is invalid. Please contact your administrator.',
  session_expired: 'Your session has expired. Please sign in again.',
  authentication_failed:
    'Authentication failed. Please try again or contact support.',
  account_disabled:
    'Your account is disabled. Please contact your administrator.',
  sso_config_error:
    'SSO is not configured for your organization. Please contact your administrator.',
  server_error: 'An unexpected server error occurred. Please try again later.',
};

const SsoCallback = () => {
  const [status, setStatus] = useState('processing'); // 'processing' | 'success' | 'error'
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const errorCode = queryParams.get('error');

    if (errorCode) {
      const message =
        SSO_ERROR_MESSAGES[errorCode] ||
        errorCode ||
        SSO_ERROR_MESSAGES['server_error'];
      setErrorMessage(message);
      setStatus('error');
      return;
    }
  }, []);

  useEffect(() => {
    if (errorMessage) {
      setTimeout(handleCloseError, 60000);
    }
  }, [errorMessage]);

  const handleCloseError = () => {
    setStatus('');
    setErrorMessage('');
    const url = new URL(window.location);
    url.searchParams.delete('error');
    window.history.replaceState({}, document.title, url.toString());
  };

  if (status === 'error') {
    return (
      <Message
        severity="error"
        icon="pi pi-exclamation-triangle"
        text={
          <div className="flex align-items-center gap-2">
            <div className="flex flex-column align-items-center">
              <h3 className="w-full text-700 mt-0 mb-0">Sign-In Failed</h3>
              <p className="text-700 m-0">
                {errorMessage}
                <br />
                <span className="text-400 mt-1 font-italic text-xs">
                  This message will disappear automatically after 60 seconds.
                </span>
              </p>
            </div>
            <Button
              onClick={handleCloseError}
              className="position-absolute top-0 right-0 m-2 p-button-rounded p-button-text"
              aria-label="Close"
              icon="pi pi-times"
            />
          </div>
        }
      />
    );
  }

  // status === 'success'
  return <></>;
};

export default SsoCallback;
